module.exports = __webpack_public_path__ + "img/police_logo.5dff8cdd.png";